import bidDeadline from './bidDeadline';
import headerText from './headerText';
import bidUnit from './bidUnit';
import bidAmount from './bidAmount';
import { buyerFees } from './buyerFees';
import { buyerStorageFees } from './buyerFees';
import { Project } from '~/types/project';

export default function (project: Project, projectCosts: any, projectState: any) {
  const bidUnitDisplay = bidUnit(project);

  const detailsTable: [label: string, value: string | undefined][] = [
    [`Current bid${bidUnitDisplay ? ` (${bidUnitDisplay})` : ''}`, bidAmount(project)],
    ['Conductor Solar fee - PV', buyerFees(project, projectCosts)],
    ['Conductor Solar fee - BESS', buyerStorageFees(projectCosts)],
  ];

  return {
    headerText: headerText(project, projectState),
    bidDeadline: bidDeadline(project),
    detailsTable
  };
}